import type { IconSvgObject } from './types';

const FryIcon: IconSvgObject = [
  ["path", { d: "M22 9.5C22 13.6421 18.6421 17 14.5 17C10.3579 17 7 13.6421 7 9.5C7 5.35786 10.3579 2 14.5 2C18.6421 2 22 5.35786 22 9.5Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 9C19 11.2091 17.2091 13 15 13C12.7909 13 11 11.2091 11 9C11 6.79086 12.7909 5 15 5C17.2091 5 19 6.79086 19 9Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 22L9 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15.125 9H15M15.25 9C15.25 9.13807 15.1381 9.25 15 9.25C14.8619 9.25 14.75 9.13807 14.75 9C14.75 8.86193 14.8619 8.75 15 8.75C15.1381 8.75 15.25 8.86193 15.25 9Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default FryIcon;
